import React from 'react';
import { Switch } from 'react-router-dom';
import { RouteWithPermissions } from 'containers/route-with-permissions';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { Index } from './downloadIndex';
import { FEATURE_TOGGLES } from 'constants/featureToggles';

export const DownloadRoutingChargeImport = () => {
    return (
        <Switch>
           <RouteWithPermissions
                path="/exception-management/charge-import/import"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_IMPORT]}
            />
            <RouteWithPermissions
                path="/exception-management/charge-import/export"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_EXPORT]}
            />
        </Switch>
    );
};